import { useAuth } from "@/components/context/AuthContext"
import styles from "./store-header.module.css"

export default function StoreHeader({ onAddProduct }) {
    const {isAuthenticated, user} = useAuth();
    return (
        <div className={styles.storeHeader}>
            <div className={styles.headerContent}>
                <h1 className={styles.title}>Pixel Moon Store</h1>
                <p className={styles.subtitle}>Digital Keys • In-Game Items • Gaming Gear • Exclusive Merchandise</p>
            </div>
            <div className={styles.headerStats}>
                <div className={styles.stat}>
                    <span className={styles.statLabel}>Products</span>
                    <span className={styles.statValue}>500+</span>
                </div>
                <div className={styles.stat}>
                    <span className={styles.statLabel}>Marketplaces</span>
                    <span className={styles.statValue}>5+</span>
                </div>
                <div className={styles.stat}>
                    <span className={styles.statLabel}>Trusted By</span>
                    <span className={styles.statValue}>50K+</span>
                </div>
                {isAuthenticated && user?.role === "admin" && (
                    <div className={`${styles.stat} ${styles.addProd}`} onClick={onAddProduct}>
                        <button className={styles.adminBtn}>
                            ➕ 
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}
